import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { formatUrl } from "../../helpers/functions";

function ProductLiNav({ product }) {

  return (
    <li className="col-12 col-lg-12 col-md-12 col-sm-6 ">
      <a className="productTitle" 
        href={product.type === 'productoLinea' ? 
          `/producto/${formatUrl(product.title)}` : 
          `/producto-especial/${formatUrl(product.title)}`}
      >
        <img
          alt={product.alt}
          src={product.imageIcon ? product.imageIcon[0]?.url : ""}
          id="imagen"
        />
        {product.title} <ArrowForwardIcon />
      </a>
    </li>
  );
}

export default ProductLiNav;
